function checkRedirect(props){

  if(props.location.search.indexOf('preview=true') ==-1){

    if(!props.siteProps['funnel']){
        props.history.push('/');
    } 

    let pagesList = ["/" , "/funnel" , "/revenue-ltv" , "/investment" , "/result"]

    if(pagesList.indexOf(props.location.pathname) == -1){
        props.history.push('/');
    }

  }

}

export default checkRedirect;


// WEBPACK FOOTER //
// ./src/components/redirect.js